/**
 * Identificador de prueba del interruptor de cortes futuros en escritorio.
 */
export const TEST_ID_SWITCH_FUTUROS = 'switch-cortes-futuros';

/**
 * Identificador de prueba del interruptor de cortes futuros en mobile.
 */
export const TEST_ID_SWITCH_FUTUROS_MOBILE = 'switch-cortes-futuros-mobile';

/**
 * Identificador de prueba del logo del header.
 */
export const TEST_ID_LOGO_HEADER = 'header-mapa-logo';

/**
 * Identificador de prueba del botón de reportar corte del header.
 */
export const TEST_ID_BOTON_REPORTAR_HEADER = 'boton-reportar-corte';

/**
 * Identificador de prueba del logo sobre el sheet mobile.
 */
export const TEST_ID_LOGO_HEADER_SHEET = 'header-mapa-logo-sheet';

/**
 * Identificador de prueba del botón flotante de reportar corte.
 */
export const TEST_ID_FAB_REPORTAR = 'fab-reportar-corte';

/**
 * Identificador de prueba del botón flotante de simbología.
 */
export const TEST_ID_FAB_SIMBOLOGIA = 'fab-simbologia';

/**
 * Identificador de prueba del panel de simbología mobile.
 */
export const TEST_ID_PANEL_SIMBOLOGIA = 'panel-simbologia-mobile';

/**
 * Identificador de prueba del cierre de la simbología mobile.
 */
export const TEST_ID_CERRAR_SIMBOLOGIA = 'cerrar-simbologia-mobile';

/**
 * Identificador de prueba del overlay del modal de reportar.
 */
export const TEST_ID_MODAL_REPORTAR_OVERLAY = 'modal-reportar-overlay';

/**
 * Identificador de prueba del fondo del modal de reportar.
 */
export const TEST_ID_MODAL_REPORTAR_BACKDROP = 'modal-reportar-backdrop';

/**
 * Identificador de prueba del modal de reportar corte.
 */
export const TEST_ID_MODAL_REPORTAR = 'modal-reportar-corte';

/**
 * Identificador de prueba del cierre del modal de reportar.
 */
export const TEST_ID_CERRAR_MODAL_REPORTAR = 'cerrar-modal-reportar';

/**
 * Identificador de prueba de la confirmación de reportar corte.
 */
export const TEST_ID_CONFIRMAR_REPORTAR = 'boton-confirmar-reportar-corte';
